import React from 'react'
import { formatMoney } from '../../utils/amount'
import { formatDateField } from '../../utils/date'
import { statusPillStyle } from '../../utils/statusColor'
import { resolvePortalPaymentStatus } from '../../utils/portalPayment'

const PortalPaymentsTable = ({ title, rows, emptyLabel, mode }) => (
  <div className="border border-divider rounded-2xl bg-surface shadow-subtle dark:shadow-none overflow-hidden mb-6">
    <div className="px-5 py-4 border-b border-divider">
      <p className="font-semibold text-[14px] text-text-primary">{title}</p>
    </div>
    {rows?.length > 0 ? (
      <table className="w-full">
        <thead className="bg-paper">
          <tr>
            <th className="py-3 px-4 text-[13px] text-text-secondary font-semibold text-left">Due Date</th>
            <th className="py-3 px-4 text-[13px] text-text-secondary font-semibold text-left">Amount</th>
            <th className="py-3 px-4 text-[13px] text-text-secondary font-semibold text-left">Status</th>
          </tr>
        </thead>
        <tbody>
          {rows.map((pmt) => {
            const display = resolvePortalPaymentStatus(pmt)

            return (
              <tr key={pmt._id} className="border-b border-divider last:border-0">
                <td className="py-3 px-4 text-sm text-text-primary">
                  {formatDateField(pmt.dueDate, 'MMM D, YYYY')}
                </td>
                <td className="py-3 px-4 text-sm text-text-primary font-medium">
                  {formatMoney(pmt.amount)}
                </td>
                <td className="py-3 px-4">
                  {display.tone === 'success' ? (
                    <span className="text-xs font-medium px-2.5 py-1 rounded-full bg-success-light text-success-main">
                      {display.label}
                    </span>
                  ) : (
                    <span
                      className="text-xs font-medium px-2.5 py-1 rounded-full"
                      style={statusPillStyle(pmt.status?.bgColor, pmt.status?.textColor, mode)}
                    >
                      {display.label}
                    </span>
                  )}
                  {display.note && (
                    <span className="block pt-1 text-xs text-text-secondary">{display.note}</span>
                  )}
                </td>
              </tr>
            )
          })}
        </tbody>
      </table>
    ) : (
      <div className="py-10 text-center text-text-secondary text-sm">{emptyLabel}</div>
    )}
  </div>
)

export default PortalPaymentsTable
